import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { fetchDepartmentIds } from '../adapaters/fetchDepartmentIds';
import { seletedDepartmentId } from '../shared/selected.department.ids';

const useFetchDepartmentIdList = () => {
  const [departmentIds, setDepartmentIds] = useAtom(
    seletedDepartmentId
  );

  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );
  const [selectedTurnItems] = useAtom(selectedTurnItem);

  useEffect(() => {
    if (selectedDepartment?.NobatBaPezeshKYaVahed === 2) {
      if (selectedDepartment && selectedTurnItems) {
        const data = {
          idDarmangah: selectedDepartment?.Id,
          idService: selectedTurnItems?.id,
        };

        fetchDepartmentIds(setDepartmentIds, data);
      }
    }
  }, [selectedDepartment, selectedTurnItems]);
};

export default useFetchDepartmentIdList;
